<template lang="pug">
#breadcrumbContainerBox
  .breadcrumbContainer
    .nav
      .navitem
        Breadcrumb
    .avatar
      //- 项目下拉框
      el-select.prjSelect(
        v-if="navArrshow",
        v-loadMore="getPrjOptions_add",
        filterable,
        placeholder="请选择",
        remote,
        :remote-method="projectFilter",
        size="small",
        :title="prjValueTitle",
        :value="prjId",
        @input="changeProject",
        @visible-change="tagChange"
      )
        el-option-group(v-for="group in options", :key="group.label", :label="group.label")
          el-option(v-for="item in group.options", :key="item.prjId", :label="item.prjName", style="width: 300px", :title="item.prjName", :value="item.prjId")
      span.avata-down(v-if="!hideHelpBtn", @click="manualHelpBtn") 帮助手册
      span.avata-down(v-if="!hideDownloadBtn", @click="plugBtn") 插件下载
      el-badge(v-if="isShow && !hideMessageBtn", :hidden="!getunread", :max="99", title="消息", :value="getunread")
        .message(@click="routerBtn")
          img(alt="消息", :src="xiaoxi")
      el-dropdown.toxclassBoxStyle(v-if="!hideUserInfoBtn", trigger="click", @command="handleClick")
        span.el-dropdown-link
          img.userAvator(v-if="userAvator", alt="头像", :src="userAvator")
          span.avatortox(v-else) {{ tox }}
          span.userNameStyle {{ userName }}
            i.el-icon--right.el-icon-arrow-down
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item.dropItem(command="gouserCneter")
            img(alt="用户中心", :src="pers")
            | 用户中心
          el-dropdown-item.dropItem(v-if="isShowMyEnterprise", command="changeEnterprise")
            img(alt="切换企业", :src="convert")
            | 切换企业
          el-dropdown-item.dropItem(command="logOut")
            img(alt="退出登录", :src="out")
            | 退出登录
  //- 插件端下载
  app-download(v-if="appDownloadShow", :app-form="appForm", :plug-form="plugForm", ref="appDownload")
  //- 帮助手册
  el-dialog(v-dialogDrag, :before-close="cancel", :close-on-click-modal="false", :close-on-press-escape="false", title="帮助手册", :visible.sync="manualDialog", width="600px")
    el-table(:data="manualList", max-height="300px", :show-header="false")
      el-table-column(label="名称", prop="name")
        template(slot-scope="scope")
          div(style="width: 100%; display: flex; align-items: center")
            img(:src="className(scope.row)")
            span(style="width: 80%; margin-left: 8px") {{ scope.row.fileName }}
      el-table-column(fixed="right", label="操作", width="120px")
        template(slot-scope="scope")
          span(style="width: 100%; display: flex; justify-content: flex-start")
            span(style="margin-right: 15px; color: var(--theme-color); cursor: pointer", @click="clickFolderFile(scope.row)") 预览
            span(style="margin-right: 15px; color: var(--theme-color); cursor: pointer", @click="uploadRow(scope.row)") 下载
</template>
<script>
import { mapActions, mapState } from "vuex";
import { getToken, downloadFile, storage } from "@/CommonDP/utils";
import { tableRowIcon, helpManual } from "@/CommonDP/utils/docPublic";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import approval from "@/CommonDP/service/approve-service";
import request from "@/CommonDP/service/login-service";
import keyCatalog from "@/CommonDP/service/folder-service";
import globalParams from "@/CommonDP/utils/globalParams";
import appDownload from "@/CommonDP/components/appDownload/index.vue";
import XtDesignService from "@/CommonDP/service/XtDesign-service";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import createProjectService from "@/CommonDP/service/createProject-service";
import Breadcrumb from "@/CommonDP/components/breadcrumb/breadcrumb.vue";
export default {
  components: { appDownload, Breadcrumb },
  data() {
    return {
      hideMessageBtn: false,
      hideDownloadBtn: false,
      hideHelpBtn: false,
      hideUserInfoBtn: false,
      navArr: [],
      path: "",
      xiaoxi: require("@/CommonDP/assets/doc/xiaoxi.png"),
      manualHelp: require("@/CommonDP/assets/standard/manualHelp.png"),
      downPlug: require("@/CommonDP/assets/standard/downPlug.png"),
      list: [],
      cur: "",
      projectInfo: {},
      out: require("@/CommonDP/assets/doc/out1.png"),
      pers: require("@/CommonDP/assets/doc/pers.png"),
      convert: require("@/CommonDP/assets/doc/convert.png"),
      manualDialog: false,
      plugForm: {
        createTime: "",
        filePath: ""
      },
      appForm: {
        createTime: "",
        filePath: ""
      },
      manualList: [],
      show1: false,
      navArrshow: false,
      appDownloadShow: false,

      prjOptions: [], // 项目列表
      page: {
        pageNum: 1,
        count: 0,
        totalPage: 1
      }, // 分页
      keyword: "", // 项目筛选关键字
      myProjects: [], // 我的项目--用于检测项目权限
      isLogOut: false
    };
  },
  computed: {
    ...mapState({
      updateNavKey: (state) => state.operationsMg.updateNavKey,
      getunread: (state) => state.projectMg.unreadNum.unReadNum,
      authRoutes: (state) => state.router.authRoutes,
      userName: (state) => state.user.name,
      userAvator: (state) => state.user.avatar,
      prjId: (state) => state.projectMg.prjId,
      prjObj: (state) => state.projectMg.prjObj, // 项目
      enterpriseId: (state) => state.enterprise.enterpriseId,
      myProjectsChange: (state) => state.projectMg.myProjectsChange, // 我的项目权限改变
      hisOptions: (state) => state.projectMg.hisOptions, // 最近访问项目
      isShowMyEnterprise: (state) => state.projectMg.isShowMyEnterprise
    }),
    isShow() {
      const list = this.authRoutes.filter((item) => item.permissionKey === "message");
      if (list.length > 0) return true;
      else return false;
    },
    tox() {
      return this.userName.charAt(0);
    },
    // 分组项目列表
    options() {
      const his = {
        label: "最近访问",
        options: [...this.hisOptions]
      };
      const prj = {
        label: "项目列表",
        options: [...this.prjOptions]
      };
      const options = [];
      if (this.hisOptions.length) options.push(his);
      if (this.prjOptions.length) options.push(prj);
      return options;
    },
    localPrjId() {
      let prjId = "";
      if (this.myProjects.length) {
        const prePrja = storage.get("updatePrjcook");
        if (this.prjObj.prjId) {
          prjId = this.prjObj.prjId;
        } else if (prePrja) {
          prjId = prePrja;
        }
      }
      return prjId;
    },
    prjValueTitle() {
      let prjName = "";
      if (this.options.length) {
        prjName = this.options[0].options.filter(({ prjId }) => prjId === this.prjId)[0]?.prjName;
      }
      return prjName;
    },
    // 当前项目id
    currentPrjId() {
      let prjId = "";
      if (this.isLogOut) return;
      if (this.localPrjId) {
        prjId = this.localPrjId;
      } else if (this.hisOptions[0]) {
        prjId = this.hisOptions[0].prjId;
      } else if (this.prjOptions[0]) {
        prjId = this.prjOptions[0].prjId;
      }
      return prjId;
    }
  },

  watch: {
    $route(newValue) {
      this.resetNavArr();
      this.$nextTick(() => {
        this.initNav(newValue);
      });
    },
    navArr() {
      if (this.navArr.length) {
        if (this.navArr[0].routeName === "项目" && this.navArr[1] && this.navArr[1].routeName !== "暂无项目") {
          this.navArrshow = true;
        } else if (this.navArr[0].routeName === "未设置关键目录") {
          this.navArrshow = true;
        } else {
          this.navArrshow = false;
        }
      } else {
        this.navArrshow = false;
      }
    },
    // 更新面包屑路径
    updateNavKey() {
      this.resetNavArr();
      this.$nextTick(() => {
        const newRoute = this.$route;
        this.initNav(newRoute);
      });
    },
    // 当前企业id
    async enterpriseId() {
      this.myProjects = [];
      this.initNav(this.$route);
      if (this.isLogOut) return;
      this.unreadNum(); // 未读
      await this.getHisOptions(); // 最近访问项目
      await this.getPrjOptions(); // 项目列表
      this.getMyProjects(); // 我的项目
    },

    // 当前项目id
    currentPrjId(val, oldVal) {
      this.setCurrentProject(val);
      if (this.navArrshow) {
        if (oldVal) this.$emit("isshow", { name: "项目" });
        // 存在旧项目id，说明是切换项目，重新进入项目
        else this.$router.push({ path: this.$route.path, query: this.$route.query }); // 不存在旧项目id，说明是刷新页面，使用当前路径
      }
    },
    // 项目有所变动，重新获取项目
    myProjectsChange() {
      if (this.isLogOut) return;
      this.getMyProjects();
      this.getHisOptions();
      this.getPrjOptions();
    }
  },
  created() {
    this.path = this.$route.path;
    this.initNav(this.$route);
    this.unreadNum(); // 未读
    this.getMyProjects(); // 我的项目
    this.getHisOptions(); // 最近访问项目
    this.getPrjOptions(); // 项目列表
    // 获取全局配置
    this.hideMessageBtn = globalParams.get("hideMessageBtn");
    this.hideDownloadBtn = globalParams.get("hideDownloadBtn");
    this.hideHelpBtn = globalParams.get("hideHelpBtn");
    this.hideUserInfoBtn = globalParams.get("hideUserInfoBtn");
  },
  methods: {
    ...mapActions(["updatePrj", "setHisOptions"]),
    // 下拉框切换项目
    async changeProject(prjId) {
      if (prjId) {
        this.updatePrj({ prjId });
      }
    },
    // 项目下拉框--弹框显隐
    tagChange(val) {
      if (val === false) {
        this.keyword = "";
        this.getHisOptions();
        this.getPrjOptions();
      }
    },
    // 项目下拉框过滤关键字
    projectFilter(val) {
      this.keyword = val || "";
      this.getHisOptions();
      this.getPrjOptions();
    },
    // 获得我的项目
    async getMyProjects() {
      const res = await workProjectBoardService.getMyProjects(this.enterpriseId);
      this.myProjects = res.data;
    },
    // 设置当前项目
    async setCurrentProject(val) {
      if (val) {
        const res = await createProjectService.viewList(val); // 项目详情
        const project = res.data || {};
        storage.set("updatePrjcook", val);
        const res2 = await keyCatalog.checkCatalogIsInit({ prjId: val });
        this.$store.dispatch("setCatalogToken", res2.data ? "1" : "0");
        const params = {
          enterpriseId: this.enterpriseId,
          businessType: "prj",
          clientType: "web",
          businessId: val // 项目id
        };
        await XtDesignService.savePubUserVisit(params);
        await this.getHisOptions();
        if (!this.prjObj.prjId || this.prjObj.prjId !== val) this.updatePrj(project);
      }
    },
    // 分页增加
    getPrjOptions_add: _.debounce(async function () {
      const { pageNum, totalPage } = this.page;
      if (Number(pageNum) < Number(totalPage)) {
        const num = Number(pageNum) + 1;
        const params = {
          enterpriseId: this.enterpriseId,
          pageNum: num,
          pageSize: 10,
          keyword: this.keyword
        };
        const res = await XtDesignService.getProjectsByUserIdWithPage(params);
        this.page.count = res.totalCount;
        this.page.pageNum = res.pageIndex;
        this.page.totalPage = res.totalPage;
        this.prjOptions = [...this.prjOptions, ...res.data];
      }
    }, 500),
    // 获得项目列表
    async getPrjOptions() {
      this.page = { pageNum: 1, count: 0, totalPage: 1 };
      const params = {
        enterpriseId: this.enterpriseId,
        pageNum: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      const res = await XtDesignService.getProjectsByUserIdWithPage(params);
      this.page.count = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.page.totalPage = res.totalPage;
      this.prjOptions = res.data;
    },
    // 获得最近访问
    async getHisOptions() {
      const params = {
        enterpriseId: this.enterpriseId,
        businessType: "prj",
        clientType: "web",
        keyword: this.keyword
      };
      const res = await XtDesignService.getUserVisitHistory(params);
      this.setHisOptions(res.data);
    },
    async setCurrentPrj() {
      await this.updatePrj({ prjId: this.currentPrjId });
      this.$router.push({ name: "project" });
    },
    // 点击一级导航刷新
    async refresh() {
      if (this.isLogOut) return;
      if (this.currentPrjId) this.setCurrentPrj({ prjId: this.currentPrjId });
      else this.$router.push({ name: "noproject" });
    },
    checkPrePrj(data) {
      // 刷新页面时
      if (this.getSetLocalPrjInfo("get") && data.some((item) => item.prjId === this.getSetLocalPrjInfo("get"))) {
        this.projectInfo = data.find((item) => item.prjId === this.getSetLocalPrjInfo("get"));
      } else {
        // 初始化时
        const updatePrjcook = storage.get("updatePrjcook");
        if (!updatePrjcook) {
          this.projectInfo = data[0];
          this.getSetLocalPrjInfo("set", data[0].prjId);
        } else {
          const bo = data.every((item) => {
            return item.prjId !== updatePrjcook;
          });
          if (!bo) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].prjId === updatePrjcook) {
                this.projectInfo = data[i];
                this.getSetLocalPrjInfo("set", updatePrjcook);
              }
            }
          } else {
            this.projectInfo = data[0];
            this.getSetLocalPrjInfo("set", data[0].prjId);
          }
        }
      }
    },
    getSetLocalPrjInfo(type, prjID) {
      if (type === "get") {
        return storage.get("updatePrjcook");
      } else {
        return storage.set("updatePrjcook", prjID);
      }
    },
    async querylist() {
      const res = await enterpriseService.usergetEnterpriseList();
      this.list = res.data;
    },
    // 初始化面包屑 和 重置
    initNav(routerInfo) {
      const routes = routerInfo.matched.map((item) => ({
        path: item.path,
        routeName: item.meta.routeName
      }));
      const filterRoutes = routes.filter((item) => item.routeName);
      const navArr = this.navArr.concat(filterRoutes);
      navArr.forEach((Item) => {
        if (!this.navArr.some((item) => item.path === Item.path)) {
          this.navArr.push(Item);
        }
      });
      this.path = this.$route.path;
    },
    resetNavArr() {
      this.navArr = [];
      this.path = "";
    },
    unreadNum() {
      this.$store.dispatch("unreadNum");
      this.$store.dispatch("GetUserInfo");
      this.$store.dispatch("getUserAvata");
    },
    routerBtn() {
      this.$router.push({ name: "message" });
      var items = this.authRoutes.filter((item) => {
        return item.permissionKey === "message";
      });
      this.$emit("isshow", items[0]);
    },
    handleClick(command) {
      switch (command) {
        case "gouserCneter":
          this.$router.push({ name: "userCneter" });
          break;
        case "changeEnterprise":
          this.$router.push({ name: "myEnterprise" });
          break;
        case "logOut":
          this.$confirm("是否退出用户?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              this.isLogOut = true;
              this.prjOptions = [];
              await request
                .logout()
                .then(async () => {
                  await this.$router.replace("/");
                })
                .catch(() => {});
            })
            .catch(() => {
              this.$message({ type: "info", message: "已取消" });
            });
          break;
        default:
          break;
      }
    },
    // 获取cookie
    getCookie(key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    async plugBtn() {
      const res = await enterpriseService.getPlugList();
      if (res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          if (item.fileType === 15 || item.fileType === 17) {
            const a = item.createTime.split(" ")[0];
            this.plugForm.createTime = a.replace(/-/g, "/");
            this.plugForm.filePath = item.filePath;
          }
          if (item.fileType === 10) {
            const a = item.createTime.split(" ")[0];
            this.appForm.createTime = a.replace(/-/g, "/");
            this.appForm.filePath = item.filePath;
          }
        });
      }
      this.appDownloadShow = true;
      this.$nextTick(() => {
        this.$refs.appDownload.showDialog();
      });
    },
    async manualHelpBtn() {
      this.manualDialog = true;
      const res = await enterpriseService.getManualList("0");
      this.manualList = res.data;
    },
    className(row) {
      return tableRowIcon(row);
    },
    cancel() {
      this.manualDialog = false;
      this.manualList = [];
    },
    uploadRow(row) {
      const filePath = row.filePath;
      const fileUrl = approval.download(filePath, getToken());
      downloadFile(fileUrl);
    },
    clickFolderFile(row) {
      const filePath = row.filePath;
      const title = row.fileName;
      const noNeedIssue = true;
      helpManual(title, filePath, noNeedIssue);
    }
  }
};
</script>

<style lang="scss">
.dropItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  img {
    margin-right: 5px;
  }
}
.dropItem:hover,
.dropItem:focus {
  color: #303113 !important;
}
</style>
<style scoped lang="scss">
#breadcrumbContainerBox {
  width: 100%;
  height: 100%;
  .breadcrumbContainer {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .navHidden {
      visibility: hidden;
    }
    .nav {
      min-width: 200px;
      .navitem {
        display: inline-block;
        vertical-align: top;
      }
    }
    .prjSelect {
      margin-left: auto;
      /deep/ .el-input__inner {
        width: 300px;
      }
    }
    .avatar {
      display: flex;
      flex-direction: row;
      align-items: center;
      .avata-down {
        font-size: 14px;
        color: var(--key-color);
        font-style: normal;
        font-weight: 400;
        cursor: pointer;
        padding: 0 10px;
      }
      .message {
        cursor: pointer;
      }
      .toxclassBoxStyle {
        margin-left: 25px;
        cursor: pointer;
        // margin-top: 7px;
        // display: inline-block;
      }
    }
    .title {
      height: 50px;
      line-height: 50px;
      color: red;
      text-align: center;
    }
  }
}
.el-breadcrumb {
  font-size: 15px !important;
  line-height: 26px !important;
}
.toxclassStyle {
  .pers {
    height: 36px;
    margin-top: 8px;
    line-height: 36px;
    text-align: center;
    img {
      vertical-align: text-bottom;
    }
    .pers_header {
      vertical-align: top;
      font-size: 14px;
      margin-left: 6px;
    }
  }
}
.toxclassStyle .pers:hover {
  background: var(--theme-color) 1c;
}
.avatortox {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.userAvator {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  margin-top: 0px;
  display: inline-block;
  vertical-align: top;
}
.userNameStyle {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  vertical-align: top;
  color: var(--key-color);
  font-size: 12px;
  margin-left: 6px;
}
</style>
